import React, { ReactNode } from 'react'

interface MessagePanelProps {
  message: ReactNode
  variant: 'info' | 'warning'
}

export const MessagePanel = ({ message, variant }: MessagePanelProps) => {
  return (
    <div className='message-panel d-flex zocks-border-color-warning-dark rounded-3 gap-3 pt-2 pb-2 pe-3 ps-3'>
      <div>
        <i className='bi bi-exclamation-triangle-fill text-warning fs-6' />
      </div>
      <div>{message}</div>
    </div>
  )
}
